// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1013px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/cookiebanner/CookieBannerComponent.scss
// module id = 1067
// module chunks = 0